(function () {
  if (window.__birdcageCartGiftInit) return;
  window.__birdcageCartGiftInit = true;

  function rootFrom(el) {
    return el && el.closest ? el.closest('[data-birdcage-cart-gift]') : null;
  }

  function syncUI(root) {
    if (!root) return;
    const noCard = root.querySelector('[data-no-card]');
    const cardWrap = root.querySelector('[data-card-fields]');
    const toEl = root.querySelector('[data-gift-to]');
    const msgEl = root.querySelector('[data-gift-message]');
    const fromEl = root.querySelector('[data-gift-from]');
    const wantedEl = root.querySelector('[data-prop-wanted]');
    const atlEl = root.querySelector('[data-atl]');
    const atlHidden = root.querySelector('[data-prop-atl]');
    const skip = !!(noCard && noCard.checked);
    if (cardWrap) cardWrap.classList.toggle('is-disabled', skip);
    [toEl, msgEl, fromEl].forEach(function (el) {
      if (!el) return;
      el.readOnly = skip;
      if (skip) el.value = '';
    });
    if (wantedEl) wantedEl.value = skip ? 'No' : 'Yes';
    if (atlHidden) atlHidden.value = (atlEl && atlEl.checked) ? 'Yes' : 'No';
  }

  function giftFields(root) {
    const noCard = root.querySelector('[data-no-card]');
    const skip = !!(noCard && noCard.checked);
    const toEl = root.querySelector('[data-gift-to]');
    const msgEl = root.querySelector('[data-gift-message]');
    const fromEl = root.querySelector('[data-gift-from]');
    const phoneEl = root.querySelector('[data-gift-phone]');
    const atlEl = root.querySelector('[data-atl]');
    return {
      To: skip ? '' : ((toEl && toEl.value.trim()) || ''),
      'Gift message': skip ? '' : ((msgEl && msgEl.value.trim()) || ''),
      From: skip ? '' : ((fromEl && fromEl.value.trim()) || ''),
      'Recipient phone': (phoneEl && phoneEl.value.trim()) || '',
      'Card message wanted': skip ? 'No' : 'Yes',
      'Authority to leave': (atlEl && atlEl.checked) ? 'Yes' : 'No'
    };
  }

  function collectAttributes(root) {
    return { attributes: giftFields(root) };
  }

  // Zapiet / Google Calendar read LINE ITEM properties — not cart attributes alone
  function applyLineItemProperties(fields) {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        const items = (cart && cart.items) || [];
        let chain = Promise.resolve();
        items.forEach(function (item, index) {
          chain = chain.then(function () {
            const existing = item.properties || {};
            const props = {};
            // 1) Size Options first (above To) for cart / checkout / Zapiet
            var variantLabel = (item.variant_title && item.variant_title !== 'Default Title') ? item.variant_title : '';
            if (variantLabel) {
              var cents = (typeof item.final_price === 'number') ? item.final_price : item.price;
              var dollars = (Number(cents) / 100).toFixed(2);
              props['Size Options'] = variantLabel + ' — $' + dollars;
            }
            // 2) Gift card fields
            if (fields['Card message wanted'] !== 'No') {
              if (fields['To']) props['To'] = fields['To'];
              if (fields['Gift message']) props['Gift message'] = fields['Gift message'];
              if (fields['From']) props['From'] = fields['From'];
            }
            props['Recipient phone'] = fields['Recipient phone'];
            props['Card message wanted'] = fields['Card message wanted'];
            props['Authority to leave'] = fields['Authority to leave'];
            // 3) Keep other existing props (e.g. Zapiet) except legacy keys we own
            Object.keys(existing).forEach(function (k) {
              if (k === 'Card' || k === 'To' || k === 'Gift message' || k === 'From' || k === 'Recipient phone' || k === 'Card message wanted' || k === 'Authority to leave' || k === 'Size Options' || k === 'Size') return;
              props[k] = existing[k];
            });
            return fetch('/cart/change.js', {
              method: 'POST',
              credentials: 'same-origin',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({
                line: index + 1,
                quantity: item.quantity,
                properties: props
              })
            }).then(function (res) {
              if (!res.ok) throw new Error('cart change failed');
              return res.json();
            });
          });
        });
        return chain;
      });
  }

  function save(root) {
    syncUI(root);
    const fields = giftFields(root);
    // Merge — Shopify /cart/update.js replaces the whole attributes object
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        const merged = Object.assign({}, (cart && cart.attributes) || {}, fields);
        return fetch('/cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes: merged })
        });
      })
      .then(function (res) {
        if (!res.ok) throw new Error('cart attributes failed');
        return applyLineItemProperties(fields);
      });
  }

  function validate(root) {
    const phoneEl = root.querySelector('[data-gift-phone]');
    const errEl = root.querySelector('[data-gift-error]');
    const phone = (phoneEl && phoneEl.value.trim()) || '';
    const ok = phone.length > 0;
    if (errEl) errEl.hidden = ok;
    if (phoneEl) phoneEl.setAttribute('aria-invalid', ok ? 'false' : 'true');
    return ok;
  }

  function activeRoot() {
    const roots = document.querySelectorAll('[data-birdcage-cart-gift]');
    for (let i = 0; i < roots.length; i++) {
      if (roots[i].offsetParent !== null || roots[i].getClientRects().length) return roots[i];
    }
    return roots[0] || null;
  }

  document.addEventListener('change', function (e) {
    const root = rootFrom(e.target);
    if (!root) return;
    syncUI(root);
    save(root).catch(function (err) { console.warn('birdcage gift save', err); });
  });

  document.addEventListener('focusout', function (e) {
    const root = rootFrom(e.target);
    if (!root) return;
    save(root).catch(function (err) { console.warn('birdcage gift save', err); });
  });

  document.addEventListener('click', function (e) {
    const btn = e.target && e.target.closest('[name="checkout"], #CartDrawer-Checkout, .cart--button-checkout');
    if (!btn) return;
    const root = activeRoot();
    if (!root) return;
    syncUI(root);
    if (!validate(root)) {
      e.preventDefault();
      e.stopPropagation();
      const phoneEl = root.querySelector('[data-gift-phone]');
      if (phoneEl) phoneEl.focus();
      return;
    }
    e.preventDefault();
    e.stopPropagation();
    save(root).finally(function () {
      if (btn.getAttribute('form')) {
        const form = document.getElementById(btn.getAttribute('form'));
        if (form) {
          const input = document.createElement('input');
          input.type = 'hidden';
          input.name = 'checkout';
          input.value = '1';
          form.appendChild(input);
          form.submit();
          return;
        }
      }
      const form = btn.closest('form');
      if (form) {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'checkout';
        input.value = '1';
        form.appendChild(input);
        form.submit();
        return;
      }
      window.location.href = '/checkout';
    });
  }, true);
})();
